import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  pt: {
    translation: {
      upsell: {
        sectionTitle: 'Ofertas na Página de Rastreamento',
        sectionDesc: 'Ofereça produtos da sua loja enquanto o cliente acompanha o pedido. As ofertas aparecem abaixo do status de rastreio.',
        enableLabel: 'Exibir ofertas de produtos na página de rastreamento',
        titleLabel: 'Título da seção (opcional)',
        titlePlaceholder: 'Ex: Você também pode gostar',
        discountLabel: 'Código de desconto (opcional)',
        discountHelp: 'Crie o código na Shopify (Descontos) e informe aqui. Ele será aplicado automaticamente no checkout da oferta.',
        searchLabel: 'Buscar produtos',
        searchPlaceholder: 'Digite para buscar produtos da sua loja',
        selectedProducts: 'Produtos selecionados',
        maxProducts: 'Você pode selecionar até 4 produtos.',
        noneSelected: 'Nenhum produto selecionado ainda.',
        add: 'Adicionar',
        remove: 'Remover',
        save: 'Salvar ofertas',
        saved: 'Configuração de ofertas salva com sucesso!',
        saveError: 'Erro ao salvar configuração de ofertas',
        loadError: 'Erro ao carregar configuração de ofertas',
        searchError: 'Erro ao buscar produtos',
        needProducts: 'Selecione pelo menos um produto para ativar as ofertas.'
      },
      navigation: {
        dashboard: 'Dashboard',
        getStarted: 'Comece Aqui',
        orders: 'Pedidos',
        emailJourneys: 'Email Journeys',
        personalization: 'Personalização',
        emailTemplates: 'Templates de Email',
        billing: 'Planos',
        settings: 'Configurações',
        howItWorks: 'Como Funciona',
        trackingPage: 'Página de Rastreamento',
        configuration: 'Configuração',
        account: 'Conta'
      },
      common: {
        loading: 'Carregando...',
        error: 'Erro',
        success: 'Sucesso',
        save: 'Salvar',
        cancel: 'Cancelar',
        back: 'Voltar',
        next: 'Próximo',
        previous: 'Anterior',
        copy: 'Copiar',
        copied: 'Copiado!',
        language: 'Idioma',
        refresh: 'Atualizar',
        viewDetails: 'Ver Detalhes',
        viewAll: 'Ver Todos',
        configure: 'Configurar',
        customize: 'Personalizar',
        upgrade: 'Fazer Upgrade',
        goToDashboard: 'Ir para Dashboard',
        status: 'Status'
      },
      dashboard: {
        title: 'Dashboard',
        subtitle: 'Visão geral dos seus pedidos e email journeys',
        currentPlan: 'Plano Atual',
        remainingTracks: 'pedidos restantes este mês',
        totalOrders: 'Total de Pedidos',
        activeJourneys: 'Journeys Ativas',
        trackedOrders: 'Pedidos Rastreados',
        recentOrders: 'Pedidos Recentes',
        noOrdersFound: 'Nenhum pedido encontrado',
        noOrdersDescription: 'Quando você tiver pedidos, eles aparecerão aqui.',
        viewAllOrders: 'Ver Todos os Pedidos',
        manageOrders: 'Gerenciar Pedidos',
        manageOrdersDescription: 'Visualize e gerencie todos os seus pedidos importados',
        viewOrders: 'Ver Pedidos',
        emailJourneysTitle: 'Email Journeys',
        emailJourneysDescription: 'Configure e monitore suas jornadas de email automáticas',
        viewJourneys: 'Ver Journeys',
        loadingDashboard: 'Carregando dashboard...',
        tableHeaders: {
          order: 'Pedido',
          customer: 'Cliente',
          total: 'Total',
          status: 'Status',
          action: 'Ação'
        },
        orderStatus: {
          pending: 'Pendente',
          paid: 'Pago',
          shipped: 'Enviado',
          delivered: 'Entregue',
          cancelled: 'Cancelado'
        }
      },
      getStarted: {
        title: 'Comece Aqui com TrackingMania',
        subtitle: 'Tudo que você precisa saber para começar a rastrear envios e encantar clientes',
        welcomeTitle: 'Bem-vindo ao TrackingMania!',
        welcomeDescription: 'TrackingMania ajuda você a manter os clientes informados sobre seus pedidos com emails de rastreamento automatizados. Vamos começar com uma visão geral rápida e um teste.',
        howItWorks: 'Como o TrackingMania Funciona',
        howItWorksDescription: 'TrackingMania envia automaticamente uma série de 22 emails lindamente projetados para manter seus clientes informados durante toda a jornada do pedido - desde a confirmação até a entrega.',
        features: {
          automatedEmails: 'Jornada de Email Automatizada',
          automatedEmailsDesc: 'Envie 22 emails de atualização de rastreamento durante o processo de envio',
          multiLanguage: 'Suporte Multi-idioma',
          multiLanguageDesc: 'Disponível em 22 idiomas para alcançar clientes globalmente',
          realTimeTracking: 'Rastreamento em Tempo Real',
          realTimeTrackingDesc: 'Mantenha os clientes informados com atualizações de envio ao vivo',
          mobileOptimized: 'Otimizado para Mobile',
          mobileOptimizedDesc: 'Templates de email bonitos que ficam ótimos em todos os dispositivos'
        },
        checklist: 'Lista de Verificação para Começar',
        quickSetupGuide: 'Guia de Configuração Rápida',
        quickSetupGuideDesc: 'Complete estes 3 passos simples para começar a rastrear pedidos e encantar clientes',
        quickSetup: {
          addTrackingPage: 'Adicionar Página de Rastreamento',
          addTrackingPageDesc: 'Crie uma página dedicada de rastreamento na sua loja e adicione ao menu de navegação',
          addTrackingPageBtn: 'Adicionar Página',
          customizeShipping: 'Personalizar Notificações de Envio',
          customizeShippingDesc: 'Configure os templates de email para combinar com sua marca e integrar com o TrackingMania',
          customizeShippingBtn: 'Configurar Templates',
          emailSettings: 'Configurar Email',
          emailSettingsDesc: 'Configure o email da sua loja, nome do remetente e outras preferências de email',
          emailSettingsBtn: 'Ir para Configurações de Email'
        },
        steps: {
          connectStore: 'Conectar Sua Loja',
          connectStoreDesc: 'Já conectado ao Shopify',
          configureSettings: 'Configurar Definições',
          configureSettingsDesc: 'Personalize suas preferências de rastreamento',
          testEmail: 'Testar Jornada de Email',
          testEmailDesc: 'Envie um email de teste para ver em ação',
          startTracking: 'Começar Rastreamento',
          startTrackingDesc: 'Rastreie e notifique clientes automaticamente'
        },
        testEmailSection: {
          title: 'Experimente - Envie um Email de Teste',
          description: 'Experimente como seus clientes receberão atualizações de rastreamento. Selecione um idioma e envie um email de teste para você.',
          selectLanguage: 'Selecionar Idioma',
          languageHelp: 'Escolha o idioma para seu email de teste',
          sendTest: 'Enviar Email de Teste',
          testWillBeSent: 'Email de teste será enviado para:',
          configureEmail: 'Configure o email da sua loja nas configurações para enviar emails de teste.',
          testInfoConfigured: 'O email de teste mostrará exatamente como a primeira atualização de rastreamento aparece para seus clientes.',
          testInfoNotConfigured: 'Configure o endereço de email da sua loja para testar a funcionalidade de email e ver como seus clientes receberão atualizações de rastreamento.'
        },
        nextSteps: {
          title: 'Pronto para Começar?',
          description: 'Depois de testar a funcionalidade de email, você pode:',
          configureSettings: 'Configurar suas preferências de rastreamento em Configurações',
          customizeTemplates: 'Personalizar templates de email em Personalização',
          manageJourneys: 'Visualizar e gerenciar jornadas de email para seus pedidos',
          monitorPerformance: 'Monitorar performance de entrega no Dashboard',
          configureSettingsBtn: 'Configurar Definições',
          customizeTemplatesBtn: 'Personalizar Templates'
        }
      },
      emailTemplates: {
        title: 'Configurar Templates de Email',
        subtitle: 'Configure templates personalizados para confirmação de envio e pedidos',
        copyTemplate: 'Copie o Template Personalizado',
        loadTemplate: 'Carregar Template',
        templateCopied: 'Template copiado com sucesso!',
        templateReady: 'Template pronto para carregar',
        applyInShopify: 'Como Aplicar o Template no Shopify',
        step: 'Passo',
        templateSettings: 'Configurações do Template',
        templateType: 'Tipo de Template',
        tryAgain: 'Tentar Novamente',
        loadingTemplate: 'Carregando template...',
        errorLoading: 'Erro ao carregar o template. Tente recarregar a página.',
        errorCopying: 'Erro ao copiar. Tente selecionar e copiar manualmente.',
        whyChange: 'Por que preciso alterar o template?',
        benefits: 'Benefícios do Template Personalizado',
        consistentTracking: 'Rastreamento Consistente',
        unifiedExperience: 'Experiência Unificada',
        lessConfusion: 'Menos Confusão',
        trackingManiaBrand: 'Marca TrackingMania',
        trackingPageConfig: 'Configuração Adicional: Página de Rastreamento na Sua Loja',
        howToConfigure: 'Como Configurar (Super Simples!)',
        directAccess: 'Acesso Direto na Loja',
        integratedExperience: 'Experiência Integrada',
        importantTip: 'Dica Importante',
        makeBackup: 'Importante: Faça um backup'
      },
      languages: {
        pt: 'Português',
        en: 'English',
        de: 'Deutsch',
        es: 'Español',
        nl: 'Nederlands'
      },
      templateTypes: {
        shipping: 'Confirmação de Envio - Template 2',
        order: 'Confirmação de Pedido - Template 1', 
        shipping_update: 'Atualização de Envio - Template 3'
      },
      emailJourneys: {
        title: 'Email Journeys',
        subtitle: 'Gerencie as jornadas de email automáticas dos seus pedidos',
        loading: 'Carregando jornadas de email...',
        activeJourneys: 'Journeys Ativas',
        pausedJourneys: 'Journeys Pausadas',
        completedJourneys: 'Journeys Concluídas',
        totalJourneys: 'Total de Journeys',
        noJourneysFound: 'Nenhuma jornada de email encontrada',
        noJourneysDescription: 'As jornadas de email são criadas automaticamente quando um pedido é importado ou podem ser iniciadas manualmente.',
        viewOrders: 'Ver Pedidos',
        confirmCancel: 'Tem certeza que deseja cancelar esta jornada de email?',
        cancelReason: 'Cancelado pelo usuário',
        status: {
          active: 'Ativa',
          paused: 'Pausada',
          completed: 'Concluída',
          cancelled: 'Cancelada'
        },
        statusFilter: 'Status da Journey',
        progress: 'Dia {{current}} de 20 ({{percentage}}%)',
        tableHeaders: {
          order: 'Pedido',
          customer: 'Cliente',
          email: 'Email',
          status: 'Status',
          lastEmail: 'Último Email',
          nextEmail: 'Próximo Email',
          actions: 'Ações'
        },
        actions: {
          view: 'Ver',
          pause: 'Pausar',
          resume: 'Retomar',
          cancel: 'Cancelar'
        }
      },
      orders: {
        title: 'Pedidos',
        subtitle: 'Gerencie os pedidos da sua loja',
        loading: 'Carregando pedidos...',
        noOrdersFound: 'Nenhum pedido encontrado',
        noOrdersDescription: 'Quando você tiver pedidos na sua loja, eles aparecerão aqui.',
        paymentStatusFilter: 'Status do Pagamento',
        tableHeaders: {
          order: 'Pedido',
          customer: 'Cliente',
          total: 'Total',
          payment: 'Pagamento',
          shipping: 'Envio',
          date: 'Data',
          actions: 'Ações'
        },
        paymentStatus: {
          pending: 'Pendente',
          authorized: 'Autorizado',
          partially_paid: 'Parcialmente Pago',
          paid: 'Pago',
          partially_refunded: 'Parcialmente Reembolsado',
          refunded: 'Reembolsado',
          voided: 'Cancelado'
        },
        fulfillmentStatus: {
          fulfilled: 'Enviado',
          partial: 'Parcial',
          restocked: 'Reestocado',
          unfulfilled: 'Não Enviado'
        },
        actions: {
          view: 'Ver',
          import: 'Importar'
        }
      },
      orderDetails: {
        loading: 'Carregando...',
        error: 'Erro',
        orderNotFound: 'Pedido não encontrado',
        breadcrumb: 'Pedidos',
        invalidDate: 'Data inválida',
        emailError: 'Por favor, insira um email válido',
        emailUpdateError: 'Erro ao atualizar email',
        deliveryStatus: 'Status de Entrega',
        customerInfo: 'Informações do Cliente',
        createdOn: 'Criado',
        percentComplete: '% concluído',
        code: 'Código',
        carrierTracking: 'Rastreamento Transportadora',
        customerNotProvided: 'Cliente não informado',
        shippingAddress: 'Endereço de Entrega',
        addressNotProvided: 'Endereço não informado',
        phone: 'Tel',
        emailJourney: 'Email Journey',
        progress: 'Progresso',
        dayOf: 'Dia',
        of: 'de',
        lastEmail: 'Último email',
        nextEmail: 'Próximo email',
        noEmailSent: 'Nenhum email enviado',
        notScheduled: 'Não agendado',
        errorsFound: 'erro(s) encontrado(s)',
        noJourneyStarted: 'Nenhuma jornada de email iniciada para este pedido',
        startJourney: 'Iniciar Journey',
        importantDates: 'Datas Importantes',
        createdOn: 'Criado em',
        updatedOn: 'Atualizado em',
        deliveredOn: 'Entregue em',
        notDeliveredYet: 'Ainda não entregue',
        trackingExpectedDate: 'Previsão de rastreio',
        notEstimated: 'Não estimado',
        trackingHistory: 'Histórico de Rastreamento',
        startEmailJourney: 'Iniciar Email Journey',
        startJourneyDescription: 'Isso iniciará uma jornada automatizada de emails para o cliente',
        journeyConsistsOf: 'A jornada consiste em 20 emails enviados ao longo dos próximos dias para acompanhar o pedido e manter o cliente informado.',
        start: 'Iniciar',
        cancel: 'Cancelar',
        save: 'Salvar',
        edit: 'Editar',
        paymentStatus: {
          paid: 'Pago',
          pending: 'Pendente',
          refunded: 'Reembolsado',
          partially_refunded: 'Parcialmente Reembolsado'
        },
        orderStatus: {
          fulfilled: 'Entregue',
          unfulfilled: 'Não Enviado',
          partial: 'Parcialmente Enviado',
          delivered: 'Entregue'
        },
        journeyStatus: {
          active: 'Ativa',
          paused: 'Pausada',
          completed: 'Concluída',
          cancelled: 'Cancelada',
          not_started: 'Não Iniciada'
        }
      },
      billing: {
        title: 'Planos',
        subtitle: 'Gerencie sua assinatura e planos',
        loading: 'Carregando dados de cobrança...',
        currentPlan: 'Plano Atual',
        currentSubscription: 'Assinatura Atual',
        price: 'Preço',
        month: 'mês',
        orderLimit: 'Limite de Pedidos',
        usage: 'Uso',
        subscribe: 'Assinar',
        cancel: 'Cancelar',
        confirmCancel: 'Tem certeza que deseja cancelar sua assinatura?',
        subscribeError: 'Erro ao criar assinatura. Tente novamente.',
        cancelError: 'Erro ao cancelar assinatura. Tente novamente.',
        subscriptionStatus: {
          active: 'Ativa',
          trialing: 'Período de Teste',
          cancelled: 'Cancelada',
          past_due: 'Vencida'
        },
        currentUsage: 'Uso Atual',
        activeStatus: 'Ativa',
        availablePlans: 'Planos Disponíveis',
        perMonth: '/mês',
        perYear: '/ano',
        monthly: 'Mensal',
        annual: 'Anual',
        save20: 'Economize 20%',
        trial7Days: '7 dias de teste grátis',
        ordersPerMonth: 'pedidos por mês',
        automaticEmailJourneys: 'Email journeys automáticas',
        customTrackingPage: 'Página de tracking personalizada',
        emailSupport: 'Suporte por email',
        usageStatistics: 'Estatísticas de Uso',
        ordersThisMonth: 'Pedidos este mês',
        period: 'Período',
        currentPlan: 'Plano Atual',
        subscribe: 'Assinar',
        useFree: 'Usar Grátis',
        planDescriptions: {
          free: 'Plano gratuito com funcionalidades básicas',
          starter: 'Ideal para lojas pequenas começando',
          premium: 'Para lojas estabelecidas com mais volume',
          scaler: 'Para lojas de alto volume e enterprise'
        },
        planFeatures: {
          ordersPerMonth: 'pedidos por mês',
          emailsWillBeSent: 'emails serão enviados',
          dropshippingMode: 'Modo dropshipping',
          customTrackingPage: 'Página de tracking personalizada',
          multiLanguageEmails: 'emails em 22 idiomas',
          ai24x7Support: 'I.A 24/7 para atender clientes',
          basicFeatures: 'Funcionalidades básicas',
          advancedAnalytics: 'Análises avançadas',
          prioritySupport: 'Suporte prioritário'
        },
        ordersUsed: 'Pedidos Utilizados',
        of: 'de',
        nextBilling: 'Próxima Cobrança',
        cancelSubscription: 'Cancelar Assinatura',
        currentPeriod: 'Período Atual',
        loadingBillingInfo: 'Carregando informações de cobrança...',
        nearLimitWarning: 'Você está próximo do limite. Considere fazer upgrade.',
        plentySpaceMessage: 'Você tem bastante espaço restante neste período.',
        choosePerfectPlan: 'Escolha o plano perfeito para seu negócio',
        simplePricing: 'Preços simples e transparentes. Atualize ou cancele a qualquer momento.',
        mostPopular: 'Mais Popular',
        planDescriptions: {
          free: 'Perfeito para começar',
          starter: 'Ideal para pequenos negócios',
          premium: 'Para negócios em crescimento',
          scaler: 'Para grandes operações'
        },
        additionalResources: 'recursos adicionais',
        currentPlan: 'Plano Atual',
        startFree: 'Começar Grátis',
        choosePlan: 'Escolher Plano',
        cancelAnytime: 'Cancele a qualquer momento',
        shopifyBilling: 'Cobrança na sua conta Shopify',
        support247: 'Suporte 24/7',
        usageStats: 'Estatísticas de Uso',
        ordersThisMonth: 'Pedidos este mês',
        cancelPlan: 'Cancelar Plano'
      },
      personalization: {
        title: 'Personalização',
        subtitle: 'Personalize a experiência do seu cliente',
        trackingPage: 'Página de Rastreamento',
        permissionsOk: 'Permissões OK',
        createDedicatedPage: 'Crie uma página dedicada na sua loja onde os clientes podem rastrear seus pedidos.',
        newPermissionsRequired: 'Novas Permissões Necessárias',
        trackingManiaUpdated: 'O TrackingMania foi atualizado!',
        additionalPermissionsNeeded: 'Para criar páginas de rastreamento, precisamos de permissões adicionais que não estavam disponíveis quando o app foi instalado inicialmente.',
        followingPermissionsRequired: 'As seguintes permissões são necessárias:',
        createPages: 'Criar páginas na sua loja',
        manageContent: 'Gerenciar conteúdo da loja',
        howToResolve: 'Como resolver:',
        uninstallTrackingMania: 'Desinstale o TrackingMania no admin da Shopify (Apps → TrackingMania → Desinstalar)',
        reinstallApp: 'Reinstale o app através da Shopify App Store',
        acceptNewPermissions: 'Aceite as novas permissões durante a instalação',
        dataWillBeMaintained: 'Não se preocupe - todos os seus dados e configurações serão mantidos durante a reinstalação.',
        permissionsNeeded: 'Permissões Necessárias',
        trackingPageActive: 'Página de rastreamento ativa',
        customersCanTrack: 'Seus clientes já podem rastrear pedidos na sua loja',
        title: 'Título',
        url: 'URL',
        createdOn: 'Criada em',
        pageTitle: 'Título da Página',
        pageUrl: 'URL da Página',
        pageTitleHelp: 'O título que aparecerá no topo da página',
        pageUrlHelp: 'A URL onde a página será acessível (apenas letras, números e hífens)',
        whatWillBeIncluded: 'O que será incluído:',
        integratedTrackingForm: 'Formulário de rastreamento integrado',
        responsiveDesign: 'Design responsivo que combina com sua loja',
        multipleTrackingCodes: 'Suporte a múltiplos códigos de rastreamento',
        carrierIntegration: 'Integração com todas as transportadoras',
        automaticStatusUpdates: 'Atualizações automáticas de status',
        trackingPageBenefits: 'Benefícios da Página de Rastreamento',
        integratedExperience: '🔗 Experiência Integrada',
        integratedExperienceDesc: 'Clientes permanecem na sua loja durante o rastreamento, mantendo a confiança na sua marca.',
        customDesign: '🎨 Design Personalizado',
        customDesignDesc: 'A página se adapta automaticamente ao tema da sua loja para uma aparência profissional.',
        responsive: '📱 Responsivo',
        responsiveDesc: 'Funciona perfeitamente em dispositivos móveis, tablets e desktops.',
        easyToUse: '🚀 Fácil de Usar',
        easyToUseDesc: 'Interface intuitiva que permite aos clientes rastrear pedidos com apenas um clique.',
        aboutToCreate: 'Você está prestes a criar uma página de rastreamento na sua loja Shopify com as seguintes configurações:',
        pageWillBeCreated: 'A página será criada e ficará imediatamente disponível para seus clientes. Você poderá editá-la posteriormente através do admin da Shopify, se necessário.',
        wantToContinue: 'Deseja continuar?',
        allCarriersIntegration: 'Integração com todas as transportadoras',
        automaticStatusUpdates: 'Atualizações automáticas de status',
        createPage: 'Criar Página',
        permissionsNeededToCreate: 'Permissões necessárias para criar a página',
        readNavigation: 'Ler menus de navegação',
        writeNavigation: 'Criar itens no menu',
        permissionRequired: 'Permissão necessária',
        pageIntegrationDescription: 'A página será integrada ao design da sua loja e oferecerá uma experiência profissional.',
        remove: 'Remover',
        confirmRemoval: 'Confirmar Remoção',
        yesRemove: 'Sim, Remover',
        cancel: 'Cancelar',
        confirmRemoveTrackingPage: 'Tem certeza que deseja remover a página de rastreamento?',
        page: 'Página',
        actionCannotBeUndone: 'Esta ação não pode ser desfeita. A página será permanentemente removida da sua loja Shopify.',
        customersWillNotAccess: 'Seus clientes não conseguirão mais acessar o formulário de rastreamento através desta página.',
        tip: 'Dica',
        canCreateNewPage: 'Você pode criar uma nova página de rastreamento a qualquer momento.',
        trackingPageBenefits: 'Benefícios da Página de Rastreamento',
        integratedExperience: 'Experiência Integrada',
        customersStayInStore: 'Clientes permanecem na sua loja durante o rastreamento, mantendo a confiança na sua marca.',
        customDesign: 'Design Personalizado',
        pageAdaptsToTheme: 'A página se adapta automaticamente ao tema da sua loja para uma aparência profissional.',
        responsive: 'Responsivo',
        worksOnAllDevices: 'Funciona perfeitamente em dispositivos móveis, tablets e desktops.',
        easyToUse: 'Fácil de Usar',
        intuitiveInterface: 'Interface intuitiva que permite aos clientes rastrear pedidos com apenas um clique.',
        confirmPageCreation: 'Confirmar Criação da Página',
        aboutToCreatePage: 'Você está prestes a criar uma página de rastreamento na sua loja Shopify com as seguintes configurações:',
        pageWillBeCreated: 'A página será criada e ficará imediatamente disponível para seus clientes.',
        canEditLater: 'Você poderá editá-la posteriormente através do admin da Shopify, se necessário.',
        wantToContinue: 'Deseja continuar?',
        createPageAction: 'Criar Página',
        cancel: 'Cancelar',
        success: 'Sucesso!',
        error: 'Erro',
        loadingPersonalizationSettings: 'Carregando configurações de personalização...',
        trackingPageBenefits: 'Benefícios da Página de Rastreamento'
      },
      zyzfyBanner: {
        title: 'Você é usuário Zyzfy?',
        subtitle: 'Conecte sua conta para desbloquear pedidos ilimitados e recursos avançados de rastreamento',
        badge: 'Premium',
        benefit1: 'Rastreamento de pedidos ilimitado',
        benefit2: 'Email journeys avançadas',
        benefit3: 'Suporte prioritário',
        emailLabel: 'Email da conta Zyzfy',
        emailPlaceholder: 'seu.email@exemplo.com',
        connectButton: 'Conectar Conta',
        noAccount: 'Não tem uma conta Zyzfy?',
        signUp: 'Cadastre-se gratuitamente',
        maybeLater: 'Talvez depois',
        invalidEmail: 'Por favor, insira um email válido',
        emailNotFound: 'Email salvo! Se você tem uma conta Zyzfy com este email, a conexão será ativada automaticamente.',
        connectionError: 'Falha na conexão. Por favor, tente novamente.',
        successTitle: 'Conta Zyzfy conectada!',
        successMessage: 'Seu TrackingMania agora está vinculado ao Zyzfy. Aproveite pedidos ilimitados e recursos avançados!',
        connectedStatus: 'Zyzfy Integrado'
      },
      settings: {
        title: 'Configurações',
        subtitle: 'Configure as definições do seu aplicativo',
        storeInfo: 'Informações da Loja',
        storeName: 'Nome da Loja',
        storeNameDescription: 'Esta informação vem do Shopify e não pode ser alterada aqui.',
        storeDomain: 'Domínio da Loja',
        storeEmail: 'Email da Loja',
        storeEmailDescription: 'Email principal da sua loja no Shopify.',
        storeDomainDescription: 'Domínio da sua loja no Shopify.',
        emailSettings: 'Configurações de Email',
        enableAutomaticEmails: 'Habilitar emails automáticos',
        enableAutomaticEmailsDescription: 'Quando habilitado, emails serão enviados automaticamente durante as jornadas.',
        senderName: 'Nome do Remetente',
        senderNameDescription: 'Nome que aparecerá como remetente dos emails.',
        supportEmail: 'Email de Suporte',
        supportEmailDescription: 'Email onde você vai receber uma cópia de todos os emails enviados para os seus clientes.',
        regionalSettings: 'Configurações Regionais',
        defaultLanguage: 'Idioma Padrão',
        defaultLanguageDescription: 'Idioma padrão para emails e página de tracking.',
        timezone: 'Fuso Horário',
        timezoneDescription: 'Fuso horário para datas e horários nos emails.',
        trackingPage: 'Página de Tracking',
        enablePublicTrackingPage: 'Habilitar página de tracking pública',
        enablePublicTrackingPageDescription: 'Quando habilitado, clientes poderão acessar uma página para acompanhar seus pedidos.',
        customDomain: 'Domínio Personalizado (Opcional)',
        customDomainDescription: 'Se você tem um domínio personalizado para a página de tracking, insira aqui.',
        apiIntegrations: 'API e Integrações',
        webhookUrl: 'Webhook URL:',
        webhookDescription: 'Configure este webhook na sua loja Shopify para receber notificações de novos pedidos automaticamente.',
        saveSettings: 'Salvar Configurações',
        settingsSavedSuccess: 'Configurações salvas com sucesso!',
        loadingSettings: 'Carregando configurações...',
        privacyPolicy: 'Política de Privacidade'
      },
      emailTemplates: {
        title: 'Configurar Templates de Email',
        subtitle: 'Configure templates personalizados para confirmação de envio e pedidos',
        problem: 'O problema: O Shopify usa um template padrão que mostra o número de rastreamento da transportadora. Como nosso sistema gera números personalizados desde o primeiro dia, seus clientes receberão dois números diferentes.',
        copyTemplate: 'Copie o Template Personalizado',
        loadTemplate: 'Carregar Template',
        templateCopied: 'Template copiado com sucesso!',
        templateReady: 'Template pronto para carregar',
        applyInShopify: 'Como Aplicar o Template no Shopify',
        step: 'Passo',
        templateSettings: 'Configurações do Template',
        templateType: 'Tipo de Template',
        tryAgain: 'Tentar Novamente',
        loadingTemplate: 'Carregando template...',
        errorLoading: 'Erro ao carregar o template. Tente recarregar a página.',
        errorCopying: 'Erro ao copiar. Tente selecionar e copiar manualmente.',
        whyChange: 'Por que preciso alterar o template?',
        benefits: 'Benefícios do Template Personalizado',
        consistentTracking: 'Rastreamento Consistente',
        unifiedExperience: 'Experiência Unificada',
        lessConfusion: 'Menos Confusão',
        trackingManiaBrand: 'Marca TrackingMania',
        trackingPageConfig: 'Configuração Adicional: Página de Rastreamento na Sua Loja',
        howToConfigure: 'Como Configurar (Super Simples!)',
        directAccess: 'Acesso Direto na Loja',
        integratedExperience: 'Experiência Integrada',
        importantTip: 'Dica Importante',
        makeBackup: 'Importante: Faça um backup',
        defaultTemplate: 'Template Padrão do Shopify',
        ourTemplate: 'Nosso Template Personalizado',
        showsCarrierNumber: 'Mostra o número da transportadora (ex: BR123456789XX)',
        showsTrackingManiaInfo: 'Mostra informações do TrackingMania e integra com nossos emails',
        solution: 'A solução: Substituir o template padrão pelo nosso template personalizado, que integra perfeitamente com os emails que enviamos desde o primeiro dia da compra, evitando confusão para seus clientes.',
        templateForShipping: 'Template para confirmação de envio em',
        shopifyAdmin: 'No seu Admin do Shopify, vá em',
        settings: 'Configurações',
        sidebarBottom: 'na parte inferior da barra lateral esquerda.',
        clickNotifications: 'Clique em',
        notifications: 'Notificações',
        settingsList: 'na lista de configurações.',
        shippingConfirmation: 'Confirmação de envio',
        orderConfirmation: 'Confirmação de pedido',  
        shippingUpdate: 'Atualização de envio',
        editCode: 'Editar código',
        consistentTracking: 'Rastreamento Consistente',
        consistentTrackingDesc: 'Seus clientes verão sempre as mesmas informações de rastreamento que enviamos',
        unifiedExperience: 'Experiência Unificada',
        unifiedExperienceDesc: 'Integração perfeita entre nossos emails e os emails do Shopify',
        lessConfusion: 'Menos Confusão',
        lessConfusionDesc: 'Evita que clientes recebam números de rastreamento diferentes',
        trackingManiaBrand: 'Marca TrackingMania',
        trackingManiaBrandDesc: 'Destaca nossa plataforma de rastreamento avançado',
        additionalConfig: 'Além dos templates de email, você pode criar uma página de rastreamento personalizada diretamente na sua loja. Seus clientes poderão acessar [SUA LOJA].com/pages/trackingmania para consultar o rastreamento dos pedidos.',
        howToConfigureSimple: 'Como Configurar (Super Simples!)',
        goToPersonalization: 'Vá para a página Personalização no painel TrackingMania',
        findTrackingSection: 'Encontre a seção "Página de Rastreamento"',
        releaseScopes: 'Libere os 2 escopos informados na página',
        clickCreatePage: 'Clique no botão "Criar Página"',
        addToMenu: 'Adicione o link no menu principal da sua loja',
        directAccess: 'Acesso Direto na Loja',
        directAccessDesc: 'Clientes podem rastrear pedidos sem sair da sua loja',
        integratedExperience: 'Experiência Integrada',
        integratedExperienceDesc: 'Página personalizada com a identidade da sua marca',
        importantTip: 'Dica Importante',
        importantTipDesc: 'Após criar a página, não esqueça de adicionar o link no menu principal da sua loja para que os clientes possam encontrar facilmente. Isso aumenta significativamente o uso da funcionalidade e melhora a experiência do cliente.',
        makeBackupTitle: 'Importante: Faça um backup',
        makeBackupDesc: 'Antes de alterar o template, recomendamos que você faça uma cópia do template original do Shopify. Assim, se precisar voltar ao template anterior, você terá uma cópia salva.'
      },
      howItWorks: {
        title: 'Como Funciona',
        heroTitle: 'Como o TrackingMania Funciona',
        heroDescription: 'TrackingMania é um sistema completo de rastreamento e comunicação que envia automaticamente emails para seus clientes durante toda a jornada de entrega, mantendo-os informados e reduzindo drasticamente os contatos com o suporte.',
        stats: {
          supportReduction: 'Redução em chamados de suporte',
          chargebackReduction: 'Redução em chargebacks',
          languages: 'Idiomas disponíveis',
          aiSupport: 'Suporte com IA'
        },
        systemOverview: {
          title: 'Visão Geral do Sistema'
        },
        features: {
          automation: {
            title: 'Emails Automatizados',
            description: 'Sistema envia 22 emails automaticamente durante toda a jornada de entrega, desde a confirmação até a entrega final.'
          },
          tracking: {
            title: 'Código de Rastreamento',
            description: 'Desde o primeiro email, o cliente recebe um código único para acompanhar sua entrega em tempo real.'
          },
          multilingual: {
            title: 'Multi-idiomas',
            description: 'Emails enviados automaticamente no idioma nativo do cliente, com suporte para 22 idiomas diferentes.'
          },
          aiSupport: {
            title: 'Chatbot com IA 24/7',
            description: 'Suporte inteligente disponível 24 horas para tirar dúvidas sobre entregas e abrir tickets quando necessário.'
          },
          integration: {
            title: 'Integração Completa',
            description: 'Plataforma de rastreamento disponível em trackingmania.com/track e integrada diretamente na loja do cliente.'
          },
          apis: {
            title: 'APIs Avançadas',
            description: 'Utilizamos APIs da track123 e 17track para fornecer informações precisas e em tempo real sobre as entregas.'
          }
        },
        emailJourney: {
          title: '22 Templates de Email - A Jornada Completa',
          description: 'Cada email é estrategicamente programado para manter o cliente informado e reduzir ansiedade durante todo o processo de entrega.',
          trackingCodeInfo: 'Importante: O código de rastreamento é fornecido desde o primeiro email, permitindo que o cliente acompanhe seu pedido desde o início.',
          phases: {
            preparation: {
              title: 'Fase 1: Preparação',
              description: 'Emails enviados durante a preparação do pedido para envio (primeiras 2h + a cada 6h)',
              timing: {
                first: '2h após pedido',
                subsequent: 'A cada 6h'
              }
            },
            transit: {
              title: 'Fase 2: Em Trânsito',
              description: 'Atualizações diárias sobre o progresso da entrega enquanto o pacote está em movimento',
              timing: {
                daily: 'Diário'
              }
            },
            outForDelivery: {
              title: 'Fase 3: Saiu para Entrega',
              description: 'Notificação importante quando o pacote está a caminho do endereço final',
              timing: {
                realTime: 'Tempo real'
              }
            },
            delivered: {
              title: 'Fase 4: Entregue',
              description: 'Confirmação final de entrega com pedido de feedback do cliente',
              timing: {
                confirmation: 'Confirmação'
              }
            }
          }
        },
        emailTiming: {
          after2Hours: 'Enviado 2 horas após a compra',
          every6Hours: 'Enviado a cada 6 horas',
          every24Hours: 'Enviado a cada 24 horas',
          outForDelivery: 'Enviado em tempo real quando sai para entrega',
          delivered: 'Enviado em tempo real quando entregue'
        },
        emailCategories: {
          preparation: 'Preparação',
          transit: 'Em Trânsito',
          outForDelivery: 'Saiu para Entrega',
          delivered: 'Entregue'
        },
        trackingPlatforms: {
          title: 'Plataformas de Rastreamento',
          online: {
            title: 'Plataforma Online',
            url: 'trackingmania.com/track',
            description: 'Plataforma profissional onde qualquer pessoa pode rastrear pedidos usando o código de rastreamento.'
          },
          store: {
            title: 'Na Sua Loja',
            url: 'sua-loja.com/pages/trackingmania',
            description: 'Página integrada diretamente em sua loja, mantendo o cliente em seu ambiente durante todo o processo.'
          },
          aiChatbot: 'Ambas as plataformas contam com chatbot 24/7 com IA para suporte instantâneo, dúvidas sobre entrega e abertura de tickets diretamente com a loja.'
        },
        languages: {
          title: '22 Idiomas Disponíveis',
          description: 'O sistema detecta automaticamente o idioma do cliente e envia todos os emails na língua apropriada. Se o idioma não estiver disponível, o padrão é inglês.'
        },
        benefits: {
          title: 'Benefícios Comprovados',
          proactiveEmails: 'Emails proativos que deixam o cliente mais seguro sobre sua compra',
          supportReduction: 'Redução de 80% a 90% em chamados no suporte interno',
          chargebackReduction: 'Mais de 80% de diminuição em chargebacks',
          customerSatisfaction: 'Aumento significativo na satisfação do cliente',
          realTimeTracking: 'Informações de entrega em tempo real quando disponíveis'
        }
      }
    }
  },
  en: {
    translation: {
      upsell: {
        sectionTitle: 'Tracking Page Offers',
        sectionDesc: 'Offer products from your store while the customer tracks their order. Offers appear below the tracking status.',
        enableLabel: 'Show product offers on the tracking page',
        titleLabel: 'Section title (optional)',
        titlePlaceholder: 'E.g.: You may also like',
        discountLabel: 'Discount code (optional)',
        discountHelp: 'Create the code in Shopify (Discounts) and enter it here. It will be applied automatically at the offer checkout.',
        searchLabel: 'Search products',
        searchPlaceholder: 'Type to search your store products',
        selectedProducts: 'Selected products',
        maxProducts: 'You can select up to 4 products.',
        noneSelected: 'No products selected yet.',
        add: 'Add',
        remove: 'Remove',
        save: 'Save offers',
        saved: 'Offer settings saved successfully!',
        saveError: 'Error saving offer settings',
        loadError: 'Error loading offer settings',
        searchError: 'Error searching products',
        needProducts: 'Select at least one product to enable offers.'
      },
      navigation: {
        dashboard: 'Dashboard',
        getStarted: 'Get Started',
        orders: 'Orders',
        emailJourneys: 'Email Journeys',
        personalization: 'Personalization',
        emailTemplates: 'Email Templates',
        billing: 'Plans',
        settings: 'Settings',
        howItWorks: 'How It Works',
        trackingPage: 'Tracking Page',
        configuration: 'Configuration',
        account: 'Account'
      },
      common: {
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        save: 'Save',
        cancel: 'Cancel',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        copy: 'Copy',
        copied: 'Copied!',
        language: 'Language',
        refresh: 'Refresh',
        viewDetails: 'View Details',
        viewAll: 'View All',
        configure: 'Configure',
        customize: 'Customize',
        upgrade: 'Upgrade',
        goToDashboard: 'Go to Dashboard',
        status: 'Status'
      },
      dashboard: {
        title: 'Dashboard',
        subtitle: 'Overview of your orders and email journeys',
        currentPlan: 'Current Plan',
        remainingTracks: 'orders remaining this month',
        totalOrders: 'Total Orders',
        activeJourneys: 'Active Journeys',
        trackedOrders: 'Tracked Orders',
        recentOrders: 'Recent Orders',
        noOrdersFound: 'No orders found',
        noOrdersDescription: 'When you have orders, they will appear here.',
        viewAllOrders: 'View All Orders',
        manageOrders: 'Manage Orders',
        manageOrdersDescription: 'View and manage all your imported orders',
        viewOrders: 'View Orders',
        emailJourneysTitle: 'Email Journeys',
        emailJourneysDescription: 'Configure and monitor your automated email journeys',
        viewJourneys: 'View Journeys',
        loadingDashboard: 'Loading dashboard...',
        tableHeaders: {
          order: 'Order',
          customer: 'Customer',
          total: 'Total',
          status: 'Status',
          action: 'Action'
        },
        orderStatus: {
          pending: 'Pending',
          paid: 'Paid',
          shipped: 'Shipped',
          delivered: 'Delivered',
          cancelled: 'Cancelled'
        }
      },
      getStarted: {
        title: 'Get Started with TrackingMania',
        subtitle: 'Everything you need to know to start tracking shipments and delighting customers',
        welcomeTitle: 'Welcome to TrackingMania!',
        welcomeDescription: 'TrackingMania helps you keep customers informed about their orders with automated tracking emails. Let\'s get you started with a quick overview and test.',
        howItWorks: 'How TrackingMania Works',
        howItWorksDescription: 'TrackingMania automatically sends a series of 22 beautifully designed emails to keep your customers informed throughout their order journey - from confirmation to delivery.',
        features: {
          automatedEmails: 'Automated Email Journey',
          automatedEmailsDesc: 'Send 22 tracking update emails throughout the shipping process',
          multiLanguage: 'Multi-language Support',
          multiLanguageDesc: 'Available in 22 languages to reach customers globally',
          realTimeTracking: 'Real-time Tracking',
          realTimeTrackingDesc: 'Keep customers informed with live shipping updates',
          mobileOptimized: 'Mobile Optimized',
          mobileOptimizedDesc: 'Beautiful email templates that look great on all devices'
        },
        checklist: 'Getting Started Checklist',
        quickSetupGuide: 'Quick Setup Guide',
        quickSetupGuideDesc: 'Complete these 3 simple steps to start tracking orders and delighting customers',
        quickSetup: {
          addTrackingPage: 'Add Tracking Page',
          addTrackingPageDesc: 'Create a dedicated tracking page in your store and add it to your navigation menu',
          addTrackingPageBtn: 'Add Tracking Page',
          customizeShipping: 'Customize Shipping Notifications',
          customizeShippingDesc: 'Configure email templates to match your brand and integrate with TrackingMania',
          customizeShippingBtn: 'Configure Templates',
          emailSettings: 'Configure Email Settings',
          emailSettingsDesc: 'Set up your store email, sender name, and other email preferences',
          emailSettingsBtn: 'Go to Email Settings'
        },
        steps: {
          connectStore: 'Connect Your Store',
          connectStoreDesc: 'Already connected to Shopify',
          configureSettings: 'Configure Settings',
          configureSettingsDesc: 'Customize your tracking preferences',
          testEmail: 'Test Email Journey',
          testEmailDesc: 'Send a test email to see it in action',
          startTracking: 'Start Tracking',
          startTrackingDesc: 'Automatically track and notify customers'
        },
        testEmailSection: {
          title: 'Try It Out - Send a Test Email',
          description: 'Experience how your customers will receive tracking updates. Select a language and send yourself a test email.',
          selectLanguage: 'Select Language',
          languageHelp: 'Choose the language for your test email',
          sendTest: 'Send Test Email',
          testWillBeSent: 'Test email will be sent to:',
          configureEmail: 'Please configure your store email in settings to send test emails.',
          testInfoConfigured: 'The test email will show you exactly how the first tracking update looks to your customers.',
          testInfoNotConfigured: 'Configure your store email address to test the email functionality and see how your customers will receive tracking updates.'
        },
        nextSteps: {
          title: 'Ready to Start?',
          description: 'Once you\'ve tested the email functionality, you can:',
          configureSettings: 'Configure your tracking preferences in Settings',
          customizeTemplates: 'Customize email templates in Personalization',
          manageJourneys: 'View and manage email journeys for your orders',
          monitorPerformance: 'Monitor delivery performance in the Dashboard',
          configureSettingsBtn: 'Configure Settings',
          customizeTemplatesBtn: 'Customize Templates'
        }
      },
      emailTemplates: {
        title: 'Configure Email Templates',
        subtitle: 'Set up custom templates for shipping and order confirmations',
        copyTemplate: 'Copy the Custom Template',
        loadTemplate: 'Load Template',
        templateCopied: 'Template copied successfully!',
        templateReady: 'Template ready to load',
        applyInShopify: 'How to Apply the Template in Shopify',
        step: 'Step',
        templateSettings: 'Template Settings',
        templateType: 'Template Type',
        tryAgain: 'Try Again',
        loadingTemplate: 'Loading template...',
        errorLoading: 'Error loading template. Try reloading the page.',
        errorCopying: 'Error copying. Try selecting and copying manually.',
        whyChange: 'Why do I need to change the template?',
        benefits: 'Custom Template Benefits',
        consistentTracking: 'Consistent Tracking',
        unifiedExperience: 'Unified Experience',
        lessConfusion: 'Less Confusion',
        trackingManiaBrand: 'TrackingMania Brand',
        trackingPageConfig: 'Additional Configuration: Tracking Page in Your Store',
        howToConfigure: 'How to Configure (Super Simple!)',
        directAccess: 'Direct Access in Store',
        integratedExperience: 'Integrated Experience',
        importantTip: 'Important Tip',
        makeBackup: 'Important: Make a backup'
      },
      languages: {
        pt: 'Portuguese',
        en: 'English',
        de: 'German',
        es: 'Spanish',
        nl: 'Dutch'
      },
      templateTypes: {
        shipping: 'Shipping Confirmation - Template 2',
        order: 'Order Confirmation - Template 1',
        shipping_update: 'Shipping Update - Template 3'
      },
      emailJourneys: {
        title: 'Email Journeys',
        subtitle: 'Manage your automated email journeys for orders',
        loading: 'Loading email journeys...',
        activeJourneys: 'Active Journeys',
        pausedJourneys: 'Paused Journeys',
        completedJourneys: 'Completed Journeys',
        totalJourneys: 'Total Journeys',
        noJourneysFound: 'No email journeys found',
        noJourneysDescription: 'Email journeys are created automatically when an order is imported or can be started manually.',
        viewOrders: 'View Orders',
        confirmCancel: 'Are you sure you want to cancel this email journey?',
        cancelReason: 'Cancelled by user',
        status: {
          active: 'Active',
          paused: 'Paused',
          completed: 'Completed',
          cancelled: 'Cancelled'
        },
        statusFilter: 'Journey Status',
        progress: 'Day {{current}} of 20 ({{percentage}}%)',
        tableHeaders: {
          order: 'Order',
          customer: 'Customer',
          email: 'Email',
          status: 'Status',
          lastEmail: 'Last Email',
          nextEmail: 'Next Email',
          actions: 'Actions'
        },
        actions: {
          view: 'View',
          pause: 'Pause',
          resume: 'Resume',
          cancel: 'Cancel'
        }
      },
      orders: {
        title: 'Orders',
        subtitle: 'Manage your store orders',
        loading: 'Loading orders...',
        noOrdersFound: 'No orders found',
        noOrdersDescription: 'When you have orders in your store, they will appear here.',
        paymentStatusFilter: 'Payment Status',
        tableHeaders: {
          order: 'Order',
          customer: 'Customer',
          total: 'Total',
          payment: 'Payment',
          shipping: 'Shipping',
          date: 'Date',
          actions: 'Actions'
        },
        paymentStatus: {
          pending: 'Pending',
          authorized: 'Authorized',
          partially_paid: 'Partially Paid',
          paid: 'Paid',
          partially_refunded: 'Partially Refunded',
          refunded: 'Refunded',
          voided: 'Voided'
        },
        fulfillmentStatus: {
          fulfilled: 'Fulfilled',
          partial: 'Partial',
          restocked: 'Restocked',
          unfulfilled: 'Unfulfilled'
        },
        actions: {
          view: 'View',
          import: 'Import'
        }
      },
      orderDetails: {
        loading: 'Loading...',
        error: 'Error',
        orderNotFound: 'Order not found',
        breadcrumb: 'Orders',
        invalidDate: 'Invalid date',
        emailError: 'Please enter a valid email',
        emailUpdateError: 'Error updating email',
        deliveryStatus: 'Delivery Status',
        customerInfo: 'Customer Information',
        createdOn: 'Created',
        percentComplete: '% complete',
        code: 'Code',
        carrierTracking: 'Carrier Tracking',
        customerNotProvided: 'Customer not provided',
        shippingAddress: 'Shipping Address',
        addressNotProvided: 'Address not provided',
        phone: 'Phone',
        emailJourney: 'Email Journey',
        progress: 'Progress',
        dayOf: 'Day',
        of: 'of',
        lastEmail: 'Last email',
        nextEmail: 'Next email',
        noEmailSent: 'No email sent',
        notScheduled: 'Not scheduled',
        errorsFound: 'error(s) found',
        noJourneyStarted: 'No email journey started for this order',
        startJourney: 'Start Journey',
        importantDates: 'Important Dates',
        createdOn: 'Created on',
        updatedOn: 'Updated on',
        deliveredOn: 'Delivered on',
        notDeliveredYet: 'Not delivered yet',
        trackingExpectedDate: 'Tracking expected date',
        notEstimated: 'Not estimated',
        trackingHistory: 'Tracking History',
        startEmailJourney: 'Start Email Journey',
        startJourneyDescription: 'This will start an automated email journey for the customer',
        journeyConsistsOf: 'The journey consists of 20 emails sent over the next few days to track the order and keep the customer informed.',
        start: 'Start',
        cancel: 'Cancel',
        save: 'Save',
        edit: 'Edit',
        paymentStatus: {
          paid: 'Paid',
          pending: 'Pending',
          refunded: 'Refunded',
          partially_refunded: 'Partially Refunded'
        },
        orderStatus: {
          fulfilled: 'Fulfilled',
          unfulfilled: 'Unfulfilled',
          partial: 'Partially Fulfilled',
          delivered: 'Delivered'
        },
        journeyStatus: {
          active: 'Active',
          paused: 'Paused',
          completed: 'Completed',
          cancelled: 'Cancelled',
          not_started: 'Not Started'
        }
      },
      billing: {
        title: 'Plans',
        subtitle: 'Manage your subscription and plans',
        loading: 'Loading billing data...',
        currentPlan: 'Current Plan',
        currentSubscription: 'Current Subscription',
        price: 'Price',
        month: 'month',
        orderLimit: 'Order Limit',
        usage: 'Usage',
        subscribe: 'Subscribe',
        cancel: 'Cancel',
        confirmCancel: 'Are you sure you want to cancel your subscription?',
        subscribeError: 'Error creating subscription. Please try again.',
        cancelError: 'Error cancelling subscription. Please try again.',
        subscriptionStatus: {
          active: 'Active',
          trialing: 'Trial Period',
          cancelled: 'Cancelled',
          past_due: 'Past Due'
        },
        currentUsage: 'Current Usage',
        availablePlans: 'Available Plans',
        perMonth: '/month',
        perYear: '/year', 
        monthly: 'Monthly',
        annual: 'Annual',
        save20: 'Save 20%',
        trial7Days: '7-day free trial',
        ordersPerMonth: 'orders per month',
        automaticEmailJourneys: 'Automatic email journeys',
        customTrackingPage: 'Custom tracking page',
        emailSupport: 'Email support',
        usageStatistics: 'Usage Statistics',
        ordersThisMonth: 'Orders this month',
        period: 'Period',
        currentPlan: 'Current Plan',
        subscribe: 'Subscribe',
        useFree: 'Use Free',
        planDescriptions: {
          free: 'Free plan with basic features',
          starter: 'Ideal for small stores getting started',
          premium: 'For established stores with higher volume',
          scaler: 'For high volume and enterprise stores'
        },
        planFeatures: {
          ordersPerMonth: 'orders per month',
          emailsWillBeSent: 'emails will be sent',
          dropshippingMode: 'Dropshipping mode',
          customTrackingPage: 'Custom tracking page',
          multiLanguageEmails: 'emails in 22 languages',
          ai24x7Support: '24/7 AI customer support',
          basicFeatures: 'Basic features',
          advancedAnalytics: 'Advanced analytics',
          prioritySupport: 'Priority support'
        },
        ordersUsed: 'Orders Used',
        of: 'of',
        nextBilling: 'Next Billing',
        cancelSubscription: 'Cancel Subscription',
        currentPeriod: 'Current Period',
        // New billing page translations
        currentPlanStatus: 'Current Plan: Premium',
        activeStatus: 'Active',
        ordersProcessed: 'Orders processed',
        monthlyLimit: 'Monthly limit',
        ordersRemaining: 'Orders remaining',
        choosePerfectPlan: 'Choose the perfect plan for your business',
        simplePricing: 'Simple and transparent pricing. Upgrade or cancel anytime.',
        mostPopular: '⭐ Most Popular',
        perfectToStart: 'Perfect to get started',
        idealSmallBusiness: 'Ideal for small businesses',
        growingBusiness: 'For growing businesses',
        largeOperations: 'For large operations',
        additionalFeatures: 'additional features',
        currentPlan: 'Current Plan',
        choosePlan: 'Choose Plan',
        startFree: 'Start Free',
        cancelAnytime: 'Cancel anytime',
        billingOnShopify: 'Billing on your Shopify account',
        support247: '24/7 Support',
        currentUsage: 'Current usage',
        youAreCloseToLimit: '⚠️ You are close to the limit. Consider upgrading.',
        plentySpaceRemaining: '✅ You have plenty of space remaining in this period.',
        nextBilling: 'Next billing',
        cancelPlan: 'Cancel Plan',
        free: 'Free',
        loadingBilling: 'Loading billing information...',
        // Missing translations
        currentPlanTitle: 'Current Plan',
        perMonth: '/month',
        nextBillingDate: 'Next billing',
        usagePercentage: 'Current usage',
        additionalResources: 'additional resources',
        loadingBillingInfo: 'Loading billing information...',
        nearLimitWarning: 'You are close to the limit. Consider upgrading.',
        plentySpaceMessage: 'You have plenty of space remaining in this period.',
        choosePerfectPlan: 'Choose the perfect plan for your business',
        simplePricing: 'Simple and transparent pricing. Upgrade or cancel anytime.',
        mostPopular: 'Most Popular',
        planDescriptions: {
          free: 'Perfect to get started',
          starter: 'Ideal for small businesses',
          premium: 'For growing businesses',
          scaler: 'For large operations'
        },
        currentPlan: 'Current Plan',
        startFree: 'Start Free',
        choosePlan: 'Choose Plan',
        cancelAnytime: 'Cancel anytime',
        shopifyBilling: 'Billing on your Shopify account',
        support247: '24/7 Support',
        usageStats: 'Usage Statistics',
        ordersThisMonth: 'Orders this month',
        currentPeriod: 'Current Period',
        cancelPlan: 'Cancel Plan'
      },
      personalization: {
        title: 'Personalization',
        subtitle: 'Customize your customer experience',
        trackingPage: 'Tracking Page',
        permissionsOk: 'Permissions OK',
        createDedicatedPage: 'Create a dedicated page in your store where customers can track their orders.',
        newPermissionsRequired: 'New Permissions Required',
        trackingManiaUpdated: 'TrackingMania has been updated!',
        additionalPermissionsNeeded: 'To create tracking pages, we need additional permissions that were not available when the app was initially installed.',
        followingPermissionsRequired: 'The following permissions are required:',
        createPages: 'Create pages in your store',
        manageContent: 'Manage store content',
        howToResolve: 'How to resolve:',
        uninstallTrackingMania: 'Uninstall TrackingMania in Shopify admin (Apps → TrackingMania → Uninstall)',
        reinstallApp: 'Reinstall the app through the Shopify App Store',
        acceptNewPermissions: 'Accept the new permissions during installation',
        dataWillBeMaintained: 'Don\'t worry - all your data and settings will be maintained during reinstallation.',
        permissionsNeeded: 'Permissions Required',
        trackingPageActive: 'Tracking page active',
        customersCanTrack: 'Your customers can already track orders in your store',
        title: 'Tracking Page',
        url: 'URL',
        createdOn: 'Created on',
        pageTitle: 'Page Title',
        pageUrl: 'Page URL',
        pageTitleHelp: 'The title that will appear at the top of the page',
        pageUrlHelp: 'The URL where the page will be accessible (letters, numbers and hyphens only)',
        whatWillBeIncluded: 'What will be included:',
        integratedTrackingForm: 'Integrated tracking form',
        responsiveDesign: 'Responsive design that matches your store',
        multipleTrackingCodes: 'Support for multiple tracking codes',
        carrierIntegration: 'Integration with all carriers',
        automaticStatusUpdates: 'Automatic status updates',
        trackingPageBenefits: 'Tracking Page Benefits',
        integratedExperience: '🔗 Integrated Experience',
        integratedExperienceDesc: 'Customers stay on your store during tracking, maintaining trust in your brand.',
        customDesign: '🎨 Custom Design',
        customDesignDesc: 'The page automatically adapts to your store theme for a professional appearance.',
        responsive: '📱 Responsive',
        responsiveDesc: 'Works perfectly on mobile devices, tablets and desktops.',
        easyToUse: '🚀 Easy to Use',
        easyToUseDesc: 'Intuitive interface that allows customers to track orders with just one click.',
        aboutToCreate: 'You are about to create a tracking page in your Shopify store with the following settings:',
        pageWillBeCreated: 'The page will be created and will be immediately available to your customers. You can edit it later through the Shopify admin if needed.',
        wantToContinue: 'Do you want to continue?',
        allCarriersIntegration: 'Integration with all carriers',
        automaticStatusUpdates: 'Automatic status updates',
        createPage: 'Create Page',
        permissionsNeededToCreate: 'Permissions required to create the page',
        readNavigation: 'Read navigation menus',
        writeNavigation: 'Create menu items',
        permissionRequired: 'Required permission',
        pageIntegrationDescription: 'The page will be integrated with your store design and provide a professional experience.',
        remove: 'Remove',
        confirmRemoval: 'Confirm Removal',
        yesRemove: 'Yes, Remove',
        cancel: 'Cancel',
        confirmRemoveTrackingPage: 'Are you sure you want to remove the tracking page?',
        page: 'Page',
        actionCannotBeUndone: 'This action cannot be undone. The page will be permanently removed from your Shopify store.',
        customersWillNotAccess: 'Your customers will no longer be able to access the tracking form through this page.',
        tip: 'Tip',
        canCreateNewPage: 'You can create a new tracking page at any time.',
        trackingPageBenefits: 'Tracking Page Benefits',
        integratedExperience: 'Integrated Experience',
        customersStayInStore: 'Customers stay in your store during tracking, maintaining trust in your brand.',
        customDesign: 'Custom Design',
        pageAdaptsToTheme: 'The page automatically adapts to your store theme for a professional appearance.',
        responsive: 'Responsive',
        worksOnAllDevices: 'Works perfectly on mobile devices, tablets and desktops.',
        easyToUse: 'Easy to Use',
        intuitiveInterface: 'Intuitive interface that allows customers to track orders with just one click.',
        confirmPageCreation: 'Confirm Page Creation',
        aboutToCreatePage: 'You are about to create a tracking page in your Shopify store with the following settings:',
        pageWillBeCreated: 'The page will be created and immediately available to your customers.',
        canEditLater: 'You can edit it later through the Shopify admin if needed.',
        wantToContinue: 'Do you want to continue?',
        createPageAction: 'Create Page',
        cancel: 'Cancel',
        success: 'Success!',
        error: 'Error',
        loadingPersonalizationSettings: 'Loading personalization settings...',
        trackingPageBenefits: 'Tracking Page Benefits',
        confirmRemoval: 'Confirm Removal',
        sureToRemove: 'Are you sure you want to remove the tracking page?',
        page: 'Page',
        actionCannotBeUndone: 'This action cannot be undone. The page will be permanently removed from your Shopify store.',
        customersCannotAccess: 'Your customers will no longer be able to access the tracking form through this page.',
        tip: 'Tip: You can create a new tracking page at any time.',
        remove: 'Remove',
        yesRemove: 'Yes, Remove'
      },
      zyzfyBanner: {
        title: 'Are you a Zyzfy user?',
        subtitle: 'Connect your account to unlock unlimited orders and advanced tracking features',
        badge: 'Premium',
        benefit1: 'Unlimited order tracking',
        benefit2: 'Advanced email journeys',
        benefit3: 'Priority support',
        emailLabel: 'Zyzfy account email',
        emailPlaceholder: 'your.email@example.com',
        connectButton: 'Connect Account',
        noAccount: "Don't have a Zyzfy account?",
        signUp: 'Sign up for free',
        maybeLater: 'Maybe later',
        invalidEmail: 'Please enter a valid email address',
        emailNotFound: 'Email saved! If you have a Zyzfy account with this email, the connection will be activated automatically.',
        connectionError: 'Connection failed. Please try again.',
        successTitle: 'Zyzfy account connected!',
        successMessage: 'Your TrackingMania is now linked to Zyzfy. Enjoy unlimited orders and advanced features!',
        connectedStatus: 'Zyzfy Integrated'
      },
      settings: {
        title: 'Settings',
        subtitle: 'Configure your application settings',
        storeInfo: 'Store Information',
        storeName: 'Store Name',
        storeNameDescription: 'This information comes from Shopify and cannot be changed here.',
        storeDomain: 'Store Domain',
        storeEmail: 'Store Email',
        storeEmailDescription: 'Primary email address of your Shopify store.',
        storeDomainDescription: 'Your store domain on Shopify.',
        emailSettings: 'Email Settings',
        enableAutomaticEmails: 'Enable automatic emails',
        enableAutomaticEmailsDescription: 'When enabled, emails will be sent automatically during journeys.',
        senderName: 'Sender Name',
        senderNameDescription: 'Name that will appear as the sender of emails.',
        supportEmail: 'Support Email',
        supportEmailDescription: 'Email where you will receive a copy of all emails sent to your customers.',
        regionalSettings: 'Regional Settings',
        defaultLanguage: 'Default Language',
        defaultLanguageDescription: 'Default language for emails and tracking page.',
        timezone: 'Timezone',
        timezoneDescription: 'Timezone for dates and times in emails.',
        trackingPage: 'Tracking Page',
        enablePublicTrackingPage: 'Enable public tracking page',
        enablePublicTrackingPageDescription: 'When enabled, customers will be able to access a page to track their orders.',
        customDomain: 'Custom Domain (Optional)',
        customDomainDescription: 'If you have a custom domain for the tracking page, enter it here.',
        apiIntegrations: 'API & Integrations',
        webhookUrl: 'Webhook URL:',
        webhookDescription: 'Configure this webhook in your Shopify store to automatically receive new order notifications.',
        saveSettings: 'Save Settings',
        settingsSavedSuccess: 'Settings saved successfully!',
        loadingSettings: 'Loading settings...',
        privacyPolicy: 'Privacy Policy'
      },
      emailTemplates: {
        title: 'Configure Email Templates',
        subtitle: 'Set up custom templates for shipping and order confirmations',
        problem: 'The problem: Shopify uses a default template that shows the carrier tracking number. Since our system generates custom numbers from day one, your customers will receive two different numbers.',
        copyTemplate: 'Copy the Custom Template',
        loadTemplate: 'Load Template',
        templateCopied: 'Template copied successfully!',
        templateReady: 'Template ready to load',
        applyInShopify: 'How to Apply the Template in Shopify',
        step: 'Step',
        templateSettings: 'Template Settings',
        templateType: 'Template Type',
        tryAgain: 'Try Again',
        loadingTemplate: 'Loading template...',
        errorLoading: 'Error loading template. Try reloading the page.',
        errorCopying: 'Error copying. Try selecting and copying manually.',
        whyChange: 'Why do I need to change the template?',
        benefits: 'Custom Template Benefits',
        consistentTracking: 'Consistent Tracking',
        unifiedExperience: 'Unified Experience',
        lessConfusion: 'Less Confusion',
        trackingManiaBrand: 'TrackingMania Brand',
        trackingPageConfig: 'Additional Configuration: Tracking Page in Your Store',
        howToConfigure: 'How to Configure (Super Simple!)',
        directAccess: 'Direct Access in Store',
        integratedExperience: 'Integrated Experience',
        importantTip: 'Important Tip',
        makeBackup: 'Important: Make a backup',
        defaultTemplate: 'Shopify Default Template',
        ourTemplate: 'Our Custom Template',
        showsCarrierNumber: 'Shows carrier number (e.g., BR123456789XX)',
        showsTrackingManiaInfo: 'Shows TrackingMania information and integrates with our emails',
        solution: 'The solution: Replace the default template with our custom template, which integrates perfectly with the emails we send from day one, avoiding customer confusion.',
        templateForShipping: 'Template for shipping confirmation in',
        shopifyAdmin: 'In your Shopify Admin, go to',
        settings: 'Settings',
        sidebarBottom: 'at the bottom of the left sidebar.',
        clickNotifications: 'Click on',
        notifications: 'Notifications',
        settingsList: 'in the settings list.',
        shippingConfirmation: 'Shipping confirmation',
        orderConfirmation: 'Order confirmation',  
        shippingUpdate: 'Shipping update',
        editCode: 'Edit code',
        consistentTracking: 'Consistent Tracking',
        consistentTrackingDesc: 'Your customers will always see the same tracking information we send',
        unifiedExperience: 'Unified Experience',
        unifiedExperienceDesc: 'Perfect integration between our emails and Shopify emails',
        lessConfusion: 'Less Confusion',
        lessConfusionDesc: 'Prevents customers from receiving different tracking numbers',
        trackingManiaBrand: 'TrackingMania Brand',
        trackingManiaBrandDesc: 'Highlights our advanced tracking platform',
        additionalConfig: 'In addition to email templates, you can create a custom tracking page directly in your store. Your customers will be able to access [YOUR STORE].com/pages/trackingmania to check order tracking.',
        howToConfigureSimple: 'How to Configure (Super Simple!)',
        goToPersonalization: 'Go to the Personalization page in the TrackingMania panel',
        findTrackingSection: 'Find the "Tracking Page" section',
        releaseScopes: 'Release the 2 scopes indicated on the page',
        clickCreatePage: 'Click the "Create Page" button',
        addToMenu: 'Add the link to your store\'s main menu',
        directAccess: 'Direct Store Access',
        directAccessDesc: 'Customers can track orders without leaving your store',
        integratedExperience: 'Integrated Experience',
        integratedExperienceDesc: 'Custom page with your brand identity',
        importantTip: 'Important Tip',
        importantTipDesc: 'After creating the page, don\'t forget to add the link to your store\'s main menu so customers can find it easily. This significantly increases feature usage and improves customer experience.',
        makeBackupTitle: 'Important: Make a backup',
        makeBackupDesc: 'Before changing the template, we recommend making a copy of Shopify\'s original template. This way, if you need to revert to the previous template, you\'ll have a saved copy.'
      },
      howItWorks: {
        title: 'How It Works',
        heroTitle: 'How TrackingMania Works',
        heroDescription: 'TrackingMania is a complete tracking and communication system that automatically sends emails to your customers throughout the entire delivery journey, keeping them informed and drastically reducing support contacts.',
        stats: {
          supportReduction: 'Reduction in support calls',
          chargebackReduction: 'Reduction in chargebacks',
          languages: 'Available languages',
          aiSupport: 'AI Support'
        },
        systemOverview: {
          title: 'System Overview'
        },
        features: {
          automation: {
            title: 'Automated Emails',
            description: 'System sends 22 emails automatically throughout the entire delivery journey, from confirmation to final delivery.'
          },
          tracking: {
            title: 'Tracking Code',
            description: 'From the first email, the customer receives a unique code to track their delivery in real-time.'
          },
          multilingual: {
            title: 'Multi-language',
            description: 'Emails sent automatically in the customer\'s native language, with support for 22 different languages.'
          },
          aiSupport: {
            title: '24/7 AI Chatbot',
            description: 'Intelligent support available 24 hours to answer delivery questions and open tickets when necessary.'
          },
          integration: {
            title: 'Complete Integration',
            description: 'Tracking platform available at trackingmania.com/track and integrated directly into the customer\'s store.'
          },
          apis: {
            title: 'Advanced APIs',
            description: 'We use track123 and 17track APIs to provide accurate and real-time delivery information.'
          }
        },
        emailJourney: {
          title: '22 Email Templates - The Complete Journey',
          description: 'Each email is strategically scheduled to keep the customer informed and reduce anxiety throughout the delivery process.',
          trackingCodeInfo: 'Important: The tracking code is provided from the first email, allowing the customer to track their order from the beginning.',
          phases: {
            preparation: {
              title: 'Phase 1: Preparation',
              description: 'Emails sent during order preparation for shipping (first 2h + every 6h)',
              timing: {
                first: '2h after order',
                subsequent: 'Every 6h'
              }
            },
            transit: {
              title: 'Phase 2: In Transit',
              description: 'Daily updates on delivery progress while the package is in motion',
              timing: {
                daily: 'Daily'
              }
            },
            outForDelivery: {
              title: 'Phase 3: Out for Delivery',
              description: 'Important notification when the package is on its way to the final address',
              timing: {
                realTime: 'Real-time'
              }
            },
            delivered: {
              title: 'Phase 4: Delivered',
              description: 'Final delivery confirmation with customer feedback request',
              timing: {
                confirmation: 'Confirmation'
              }
            }
          }
        },
        emailTiming: {
          after2Hours: 'Sent 2 hours after purchase',
          every6Hours: 'Sent every 6 hours',
          every24Hours: 'Sent every 24 hours',
          outForDelivery: 'Sent in real-time when out for delivery',
          delivered: 'Sent in real-time when delivered'
        },
        emailCategories: {
          preparation: 'Preparation',
          transit: 'In Transit',
          outForDelivery: 'Out for Delivery',
          delivered: 'Delivered'
        },
        trackingPlatforms: {
          title: 'Tracking Platforms',
          online: {
            title: 'Online Platform',
            url: 'trackingmania.com/track',
            description: 'Professional platform where anyone can track orders using the tracking code.'
          },
          store: {
            title: 'In Your Store',
            url: 'your-store.com/pages/trackingmania',
            description: 'Page integrated directly into your store, keeping the customer in your environment throughout the process.'
          },
          aiChatbot: 'Both platforms feature 24/7 AI chatbot for instant support, delivery questions, and opening tickets directly with the store.'
        },
        languages: {
          title: '22 Available Languages',
          description: 'The system automatically detects the customer\'s language and sends all emails in the appropriate language. If the language is not available, the default is English.'
        },
        benefits: {
          title: 'Proven Benefits',
          proactiveEmails: 'Proactive emails that make customers more confident about their purchase',
          supportReduction: '80% to 90% reduction in internal support calls',
          chargebackReduction: 'Over 80% decrease in chargebacks',
          customerSatisfaction: 'Significant increase in customer satisfaction',
          realTimeTracking: 'Real-time delivery information when available'
        }
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt', // Default to Portuguese (Brazil)
    debug: process.env.NODE_ENV === 'development',
    
    // Language detection configuration
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // React i18next configuration
    react: {
      useSuspense: false,
    },
  });

export default i18n;